module.exports = __webpack_public_path__ + "static/img/logo.f5df04d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 54